import { keyBy } from 'lodash';

import {
  fetchCourseRequestsTypes,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

export default makeRequestReducer({
  types: fetchCourseRequestsTypes,
  name: 'adminCourseRequests',
  mutate: (state, res) => keyBy(res, '_id'),
});



// WEBPACK FOOTER //
// ./src/modules/requests/reducers.js